import React, { useState, useEffect } from 'react'

function FlightBanner() {
    const [bannerData, setBannerData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetchBannerData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/flight-page/`)
                if (!response.ok) {
                    throw new Error('Failed to fetch banner data')
                }
                const data = await response.json()
                setBannerData(data.banner)
                setLoading(false)
            } catch (err) {
                setError(err.message)
                setLoading(false)
            }
        }

        fetchBannerData()
    }, [])

    if (loading) {
        return (
            <div className="banner-five-wrap">
                <div className="banner-five-bg" style={{
                    backgroundColor: '#f8f9fa',
                    minHeight: '600px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        )
    }

    if (error || !bannerData) {
        return (
            <div className="banner-five-wrap">
                <div className="banner-five-bg" style={{
                    backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(/assets/img/bg/flight-banner-bg.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '600px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="banner-five-content text-center">
                                    <h1 className="text-white mb-4">
                                        Find Your Perfect Flight
                                    </h1>
                                    <p className="text-white mb-5 fs-18">
                                        Compare prices from hundreds of airlines and travel agents.<br />
                                        Find the cheapest, fastest or best flights for your trip.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="banner-five-wrap">
            <div className="banner-five-bg" style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${bannerData.background_image || '/assets/img/bg/flight-banner-bg.jpg'})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '600px',
                display: 'flex',
                alignItems: 'center'
            }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="banner-five-content text-center">
                                <h1 className="text-white mb-4">
                                    {bannerData.title || 'Find Your Perfect Flight'}
                                </h1>
                                <p className="text-white mb-5 fs-18">
                                    {bannerData.subtitle || 'Compare prices from hundreds of airlines and travel agents. Find the cheapest, fastest or best flights for your trip.'}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FlightBanner
